<script setup>
import CFBanner from '@/ui/Banner/CFBanner.vue';
</script>

<template>
    <CFBanner>
        {{ $t('banner.two_factor_authentication_enforced') }}
        <RouterLink
            :to="{ name: 'tfa setup' }"
            class="font-bold underline underline-offset-3"
        >
            {{ $t('banner.two_factor_authentication_enforced_link') }}
        </RouterLink>
    </CFBanner>
</template>
